module.exports = __webpack_public_path__ + "img/icone-pessoa-juridica.e248fbee.png";